// ===================================================================
// 🪟 COMPONENTE DE MODAL
// ===================================================================

import React, { useEffect, useCallback } from 'react';
import { styles } from '../../styles/globalStyles';

export const Modal = React.memo(({ isOpen, onClose, title, children, large = false }) => {
  const handleEscape = useCallback((event) => {
    if (event.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, handleEscape]);

  if (!isOpen) return null;

  const modalContentStyle = {
    ...styles.modalContent,
    ...(large === true && { maxWidth: '900px' }),
    ...(large === 'extra' && { maxWidth: 'min(95vw, 1200px)' }),
    ...(large === 'conference' && {
      maxWidth: 'min(98vw, 1600px)',
      maxHeight: '94vh',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: 16,
    }),
  };

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div 
        data-modal-content
        style={modalContentStyle} 
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ ...styles.modalHeader, flexShrink: 0 }}>
          <h2 style={styles.modalTitle}>{title}</h2>
          <button 
            onClick={onClose}
            style={{
              ...styles.modalClose,
              background: 'rgba(0,0,0,0.06)',
              borderRadius: '6px',
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            aria-label="Fechar modal"
          >
            ×
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}); 